var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E9CAD206-DCD8-445F-81F4-205BA6D40564") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.66666667e-06 0 18.2 0 18.2 2.599974 8.66666667e-06 2.599974"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "8.66666667e-06 -2.6e-05 18.2 -2.6e-05 18.2 2.599974 8.66666667e-06 2.599974"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resource-Library",
    transform: "translate(-316.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "docs",
    transform: "translate(316.000000, 403.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#4086F4",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(6.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9000087,2.599974 L1.30000867,2.599974 C0.581455333,2.599974 8.66666667e-06,2.01852733 8.66666667e-06,1.299974 C8.66666667e-06,0.581420667 0.581455333,-2.6e-05 1.30000867,-2.6e-05 L16.9000087,-2.6e-05 C17.618562,-2.6e-05 18.2000087,0.581420667 18.2000087,1.299974 C18.2000087,2.01852733 17.618562,2.599974 16.9000087,2.599974",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 5.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9000087,2.599974 L1.30000867,2.599974 C0.581455333,2.599974 8.66666667e-06,2.01852733 8.66666667e-06,1.299974 C8.66666667e-06,0.581420667 0.581455333,-2.6e-05 1.30000867,-2.6e-05 L16.9000087,-2.6e-05 C17.618562,-2.6e-05 18.2000087,0.581420667 18.2000087,1.299974 C18.2000087,2.01852733 17.618562,2.599974 16.9000087,2.599974",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.7000087,12.999974 L1.30000867,12.999974 C0.581455333,12.999974 8.66666667e-06,12.4185273 8.66666667e-06,11.699974 C8.66666667e-06,10.9814207 0.581455333,10.399974 1.30000867,10.399974 L11.7000087,10.399974 C12.418562,10.399974 13.0000087,10.9814207 13.0000087,11.699974 C13.0000087,12.4185273 12.418562,12.999974 11.7000087,12.999974",
    id: "Fill-7",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.73f66ae9.svg";
export { ForwardRef as ReactComponent };